import { render, staticRenderFns } from "./SPRValidationError.vue?vue&type=template&id=b2975c96&scoped=true"
import script from "./SPRValidationError.vue?vue&type=script&lang=ts"
export * from "./SPRValidationError.vue?vue&type=script&lang=ts"
import style0 from "./SPRValidationError.vue?vue&type=style&index=0&id=b2975c96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2975c96",
  null
  
)

export default component.exports